<template>
  <div>
    <comHeaderAnyone :propScreenTitle="screenTitle"></comHeaderAnyone>
    <v-main>
      <v-container fluid>
        <v-expansion-panels id="expansion-oya" v-model="panelNo">

          <v-expansion-panel v-for="help in helpList" :key="help.id">
            <v-expansion-panel-header class="panel-oya-title" v-show="panelViewFlgs[help.id - 1]">
              {{ help.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content v-show="panelViewFlgs[help.id - 1]">
              <v-expansion-panels class="mb-6" id="expansion-ko">
                <v-expansion-panel v-for="detail in help.detail" :key="detail.id">
                  <v-expansion-panel-header expand-icon="mdi-menu-down" class="panel-ko-title">
                    <div>
                      <v-icon color="primary">mdi-chat-question</v-icon>
                      {{ detail.name }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="grey lighten-4">
                    <span v-html="detail.description"></span>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
        <br />
        <!-- ボタンエリア -->
        <v-row>
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" dark min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
export default {
  name: "Help",
  props: ["kbnTyp", "KbnCd"],
  data() {
    return {
      screenTitle: "ヘルプ",
      panelViewFlgs:[false, false, false],
      helpList: [],
      panelNo: Number(this.KbnCd),
    };
  },
  created() {
    this.initialize();
  },
  openPanel() {
    this.panel.push(this.KbnCd);
  },
  methods: {
    initialize() {
      this.panelViewFlgs[this.panelNo] = true;
      this.helpList = this.$store.getters["terms/getHelpInfo"];
    },
    // CloseWindow() {
    //   window.close();
    //   return false;
    // },
    /*
    * 戻るボタン押下
    */
    back(){
      // 遷移元画面へ戻る
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "PSS100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
  },
};
</script>

<style>
#expansion-oya {
  margin: 20px 0px;
}

#expansion-ko {
  margin: 20px 0px;
}

.panel-oya-title {
  color:#ffffff;
  background-color: #3949AB;
  font-size: 1.2em;
}

.panel-ko-title {
  background-color: #eeeeee;
}
</style>
